var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1f5d46",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260 120c0-25 20-45 45-45 5 0 10 1 15 3-6 30-29 60-56 72a45 45 0 0 1-4-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 120c0-25-20-45-45-45-5 0-10 1-15 3 6 30 29 60 56 72a45 45 0 0 0 4-30z"
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 260,
    fontSize: 80
  }, "Praktiker"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 320,
    fontSize: 40,
    letterSpacing: 5,
    fill: "#2e7d5a"
  }, "NONWOVEN"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ac31b34455d771e16fdcbb7203487a83.svg";
export { ForwardRef as ReactComponent };